




















import { Vue, Component } from "vue-property-decorator";
import RecordForm from "@/components/records/RecordForm.vue";
import { Video as IVideo } from "@/api/models/video";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, RecordForm }
})
export default class RecordEdit extends Vue {
  video!: IVideo;
  data() {
    return {
      video: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "records" },
        label: this.$tc(this.$translate.Records)
      },
      {
        to: { name: "recordView", params: { id: this.$route.params.id } },
        label: this.video.title
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  mounted() {
    api.VideoApi.get(this.$route.params.id)
      .then((res: { data: IVideo }) => {
        this.video = res.data;
        document.title += ` ${this.video.title}`;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
}
